module.exports = __webpack_public_path__ + "img/zhumeng2.5279f219.png";